import { render, staticRenderFns } from "./allOrder.vue?vue&type=template&id=28fc8fda&scoped=true"
import script from "./allOrder.vue?vue&type=script&lang=js"
export * from "./allOrder.vue?vue&type=script&lang=js"
import style0 from "./allOrder.vue?vue&type=style&index=0&id=28fc8fda&prod&lang=scss"
import style1 from "./allOrder.vue?vue&type=style&index=1&id=28fc8fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fc8fda",
  null
  
)

export default component.exports